import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import UserRoles from "constants/UserRoles";


const breadcrumbsStatic = [{
	name: 'Field Engineers',
	url: '/engineers',
	icon: 'dashboard',
}];

class Engineers extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state = {
			customer_name: '',
			customer_address: '',
			field_engineer: '',
			saveTicket: false,
			filterDate: new Date()
		};
		this.setDate = this.setDate.bind(this);
	}

	access = [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.FieldEngineer, UserRoles.Developer, UserRoles.HelpDesk];

	setDate = (date) => {
		this.setState({
			filterDate: date
		});
	}

	render() {
		let {
			match,
			history,
			roles,
		} = this.props;

		return (
			<div>
				<Framework.Components.PageBar history={history}/>

				{/*<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Calendar" value="calendar" data-cy={"calendar-tab"}/>
					<Tab label="Map" value="map" data-cy={'map-tab'}/>
				</Tabs>*/}

				{/*<div className={classNames({'hidden': this.state.tab !== 'calendar'})}>*/}
							<Collections.EngineerCalendar
								history={this.props.history}
								currentFE={this.props.currentFE}
								passDate={this.setDate}
								field_engineer={this.props.rootState.user}
							/>
				{/*</div>*/}

				{/*<div className={classNames({'hidden': this.state.tab !== 'map'})}>
						<Objects.ScheduleMapFE
							id={match.params.id}
							history={this.props.history}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
							updateName={this.updateName}
							baseUrl={this.props.baseUrl}
							customer_address={this.state.customer_address}
							customer_name={this.state.customer_name}
							field_engineer={this.state.field_engineer}
							filterDate={this.state.filterDate}
						/>
				</div>*/}
			</div>
		)
	}
}
export default Framework.Components.withRootState(Engineers);




